export default {
    "Bem vindo(a) ao": "Bem vindo(a) ao",
    "Entre com suas credenciais": "Entre com suas credenciais",
    "do Ginfo abaixo": "do Ginfo abaixo",
    "Empresa": "Empresa",
    "empresa_login": "Empresa",
    "Selecione a empresa": "Selecione a empresa",
    "E-mail": "E-mail",
    "Senha": "Senha",
    "Lembrar de mim": "Lembrar de mim",
    "Entrar": "Entrar",
    "Solicite seu acesso": "Solicite seu acesso",

    "Portugues": "Português",
    "Mercosul": "Mercosul",
    "Ingles": "Inglês",
    'Frances': "Frances",
    'Alemao': 'Alemao',
    'Holandes': 'Holandes',
    'Carregando': 'Loading',
    'TODOS': 'TODOS',
    'BELGIUM': 'BÉLGICA',
    'GERMANY': 'ALEMANHA',
    'SELECIONE_O_PAIS': 'Selecione o país',
    'PAIS': 'País',
    "inicio": "Início",
    "bem_vindo": "Bem-vindo(a) ao",
    "ginfo_analytics": "GINFO Analytics",
    "informacoes_inteligentes": "Informações inteligentes para decisões mais rápidas, seguras e estratégicas",
    "acessados_recentemente": "Acessados recentemente",
    "agora": "agora",
    "ha": "há",
    "minutos": "min",
    "horas": "h",
    "ontem": "ontem",
    "dias": "dias",
    "semanas": "sem",
    "buscar_relatorio": "Buscar relatório",
    "nenhum_relatorio_encontrado": "Nenhum relatório encontrado.",
    "acesso_power_bi": "Acesso Power BI",
    "ajuda": "Ajuda",
    "sair": "Sair",
    "buscar_abrir_relatorio": "Buscar e abrir relatório",
    "mostrar_senha": "Mostrar senha",
    "ocultar_senha": "Ocultar senha",
    "esqueceu_senha": "Esqueceu a senha?",
    "login_frase_inicio": "Decisões melhores começam",
    "login_frase_destaque": "com a informação certa",
    "login_frase_2": "no momento certo",
    "login_frase_3": "no lugar certo",
    "recarregar_relatorio": "Atualizar relatório",
    "fechar_aba": "Fechar aba",
    "horarios_atualizacao": "Horários de atualização",
    "Login incorreto, insira as informações novamente": "Login incorreto, insira as informações novamente",
    "tutorial_desta_tela": "Tutorial dessa tela",
    "fechar": "Fechar",
    "carregando_tutorial": "Carregando tutorial...",
    "tutorial_indisponivel": "Tutorial indisponível para esta tela no momento.",
    "passo": "Passo"
}